import React, { Component } from 'react';
import LdapServer from './ldapServer';

export default class LdapServerGrid extends Component {

    render() {

        return(
            <div>
                {
                    this.props.ldapServers.map((server) => {

                        return <LdapServer key={server.id} server={server} />;
                    })
                }
            </div>
        );
    }
}